import { render, staticRenderFns } from "./ListConf.vue?vue&type=template&id=f31a257c&scoped=true&"
import script from "./ListConf.vue?vue&type=script&lang=js&"
export * from "./ListConf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31a257c",
  null
  
)

export default component.exports